import { SLOTS_APIS } from "@/api_framework/api_config";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => { });

type ExemptionReasonL2 = {
  id: number;
  title: string;
  error_message?: string;
};

type ExemptionReasonL1 = {
  id: number;
  title: string;
  reasons: ExemptionReasonL2[];
};

type BookingExemptionDetails = {
  eligible_exemptions: ExemptionReasonL1[];
  exemption_required_for_deletion: boolean;
  exemption_type?: string;
};

const defaultBookingExemptionDetails: BookingExemptionDetails = {
  eligible_exemptions: [],
  exemption_required_for_deletion: true,
  exemption_type: "",
};

export const useBookingExemptiopnDetailsAPI = () => {
  const [exemptionReason, setExemptionReason] = useState<BookingExemptionDetails>(defaultBookingExemptionDetails);
  const [exemptionMessage, setExemptionMessage] = useState<string | null>(null);
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (
      bookingId: string,
      queryParams?: {
        cart_item_unique_id?: string;
        intent?: string;
      },
    ) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const res: AxiosResponse<any> = await axios.get(
          `${SLOTS_APIS?.BOOKING_EXEMPTION_REASON?.baseURL}eligible/${bookingId}`,
          {
            params: queryParams ?? {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (res.data.status === true && res.data) {
          const rawData = res.data?.data;
          const data: BookingExemptionDetails = {
            eligible_exemptions: Array.isArray(rawData?.eligible_exemptions) ? rawData.eligible_exemptions : [],
            exemption_required_for_deletion: rawData?.exemption_required_for_deletion !== false,
            exemption_type: rawData?.exemption_type ?? "",
          };
          setExemptionReason(data);
          setExemptionMessage(res.data.message ?? null);
          return {
            status: true,
            message: res.data.message ?? null,
            data,
            exemption_required_for_deletion: rawData?.exemption_required_for_deletion,
          };
        }

        setExemptionReason(defaultBookingExemptionDetails);
        setExemptionMessage(res.data?.message ?? null);
        return { status: false, message: res.data?.message ?? null, data: defaultBookingExemptionDetails };
      } catch (e: any) {
        const axiosError = e as AxiosError;
        setExemptionReason(defaultBookingExemptionDetails);
        const errorMessage =
          (axiosError?.response?.data as any)?.message ?? axiosError.message ?? "This Appointment is not eligible for Exemption.";
        setExemptionMessage(errorMessage);
        sendCurl(axiosError?.config?.["curlCommand"]);
        return { status: false, message: errorMessage, data: defaultBookingExemptionDetails };
      }
    },
    [configuration, sendCurl],
  );

  return { exemptionReason, exemptionMessage, execute };
};
